import { CreatorContextDispatch } from 'controllers/business/Creator/Creator.types';
import {
    IPurchaseContext,
    PurchaseContextStartPurchase,
} from 'controllers/business/Purchase/Purchase.types';
import { useDownloadClickHandler } from 'hooks/useDownloadClickHander/useDownloadClickHander';
import { CreatorDownloadSource } from 'types';
import { DownloadType } from 'types/enums';

type UseClickHandlers = ({
    startPurchase,
    creatorDownloadSource,
    dispatch,
}: {
    startPurchase: PurchaseContextStartPurchase;
    creatorDownloadSource: CreatorDownloadSource;
    dispatch: CreatorContextDispatch;
    purchaseController: IPurchaseContext;
}) => {
    handleDownloadFullTrackClick: (e: React.MouseEvent) => void;
    handleDownloadSamplesClick: (e: React.MouseEvent) => void;
    handleAddSamplesToCollectionClick: () => void;
};

export const useClickHandlers: UseClickHandlers = ({
    creatorDownloadSource,
    dispatch,
    purchaseController,
}) => {
    const handleAddSamplesToCollectionClick = (): void =>
        dispatch({ type: 'newInstrumentationSessionId' });

    const handleDownloadFullTrack = useDownloadClickHandler({
        item: { ...creatorDownloadSource, type: DownloadType.CreatorMixdown },
        purchaseController,
    });

    const handleDownloadSamples = useDownloadClickHandler({
        item: creatorDownloadSource,
        purchaseController,
    });

    const handleDownloadFullTrackClick = (e: React.MouseEvent): void => {
        dispatch({
            type: 'newInstrumentationSessionId',
        });

        handleDownloadFullTrack(e);
    };

    const handleDownloadSamplesClick = (e: React.MouseEvent): void => {
        dispatch({
            type: 'newInstrumentationSessionId',
        });

        handleDownloadSamples(e);
    };

    return {
        handleAddSamplesToCollectionClick,
        handleDownloadSamplesClick,
        handleDownloadFullTrackClick,
    };
};
